const IndustryList = [
    "Select",
    "Pharmaceuticals",
    "Food & Beverage Processing",
    "Textile & Garments",
    "Paper & Pulp",
    "Chemicals",
    "Refineries",
    "Petrochemicals",
    "Distilleries",
    "Plastic & Polymer",
    "Cement",
    "Fertilizer",
    "Paint & Coatings",
    "Steel & Metals",
    "Glass Manufacturing",
    "Automobile & Auto Components",
    "Electronics Assembly / Manufacturing",
    "Thermal Power Plants",
    "Renewable Energy (Biomass / Solar Thermal)",
    "Water Treatment Plants (ETP/STP/WTP)",
    "Captive Power Plants",
    "Gasification & Fuel Conversion Plants",
    "Rice Mills / Flour Mills",
    "Dairy Processing",
    "Tea & Coffee Industry",
    "Cold Storage / Refrigeration Units",
    "Hospitals",
    "Hotels / Hospitality Chains",
    "Educational Institutions",
    "Commercial Building",
    "Railway",
    "Others"
];


export default IndustryList;
